var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "manual-dock-out"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), (!_vm.roleConfigLoaded) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('p', {
    staticClass: "text-muted text-center",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Loading access configuration...")])])], 1) : (!_vm.hasManualDockOutAccess) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('b-card', [_c('p', {
    staticClass: "text-danger text-center",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n            You do not have access to Manual Dock-Out. Please contact your administrator.\n          ")])])], 1) : _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchSessions.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Search By")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('basic-select', {
    attrs: {
      "options": _vm.searchTypeOptions,
      "selected-option": _vm.selectedSearchType,
      "placeholder": "Select Search Type"
    },
    on: {
      "select": _vm.onSearchTypeSelect
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Search Value")]), (_vm.isSearchValueRequired) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.searchPlaceholder
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSearchDisabled
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset\n                ")])])])])]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "space-between",
      "margin-bottom": "10px"
    }
  }, [_c('h6', {
    staticClass: "text-primary",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("\n              Active dock sessions\n              "), (_vm.sessionData.length > 0) ? _c('span', {
    staticClass: "badge badge-success",
    staticStyle: {
      "margin-left": "8px",
      "background-color": "#28a745",
      "color": "#fff",
      "padding": "3px 8px",
      "border-radius": "10px",
      "font-size": "12px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.sessionData.length) + " found\n              ")]) : _c('span', {
    staticClass: "badge badge-secondary",
    staticStyle: {
      "margin-left": "8px",
      "background-color": "#6c757d",
      "color": "#fff",
      "padding": "3px 8px",
      "border-radius": "10px",
      "font-size": "12px"
    }
  }, [_vm._v("\n                0 found\n              ")])]), _vm._v(" "), (_vm.sessionData.length > 0) ? _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Select a reason for each row to enable the Dock-Out button")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dock ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Vehicle No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Trip ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Dock In")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Duration")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Reason")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.sessionData), function(data, index) {
    return (_vm.sessionData.length > 0) ? _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.dock_id || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.vehicle_number))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.trip_id || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.route || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment1")(data.dock_in_time)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.duration || '--'))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "min-width": "200px",
        "overflow": "visible",
        "position": "relative",
        "z-index": "10"
      }
    }, [_c('basic-select', {
      attrs: {
        "options": _vm.reasonOptions,
        "selected-option": data.selectedReason,
        "placeholder": "Select Reason"
      },
      on: {
        "select": function (option) { return _vm.onReasonSelect(option, index); }
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button",
        "disabled": !data.selectedReason || !data.selectedReason.value
      },
      on: {
        "click": function($event) {
          return _vm.confirmDockOut(data, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sign-out"
    }), _vm._v(" Dock Out\n                    ")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.sessionData.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])])], 1)], 1)])]), _vm._v(" "), (_vm.hasManualDockOutAccess) ? _c('b-modal', {
    attrs: {
      "title": "Confirm Dock Out"
    },
    model: {
      value: (_vm.dockOutModalShow),
      callback: function($$v) {
        _vm.dockOutModalShow = $$v
      },
      expression: "dockOutModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Are you sure you want to dock out vehicle "), _c('strong', [_vm._v(_vm._s(_vm.dockOutVehicle))]), _vm._v(" from dock "), _c('strong', [_vm._v(_vm._s(_vm.dockOutDockId || '(no dock assigned)'))]), _vm._v("?")]), _vm._v(" "), _c('p', [_vm._v("Reason: "), _c('strong', [_vm._v(_vm._s(_vm.dockOutReason))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.executeDockOut
    }
  }, [_vm._v("Yes, Dock Out")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.dockOutModalShow = false
      }
    }
  }, [_vm._v("Cancel")])])])])]) : _vm._e()], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticStyle: {
      "border": "0px"
    }
  }, [_vm._v("Manual Dock Out")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5923fa","hasScoped":true}!./src/views/components/ManualDockOut/ManualDockOut.html
// module id = 2064
// module chunks = 2